import { fileStatuses, fileTypes } from '../../../../../../constants/cases';

export const getSavedAlignmentAnalysisFile = (files = []) =>
  files.find((file) => file.type === fileTypes.alignmentAnalysis && file.status !== fileStatuses.REJECTED);

export const prepareAlignmentAnalysisFile = ({ activeCase, planFile, date, userId }) => {
  const files = [...(activeCase.files || [])];
  const isSavedFile = planFile?.id && planFile.type === fileTypes.alignmentAnalysis;

  if (!planFile || isSavedFile) {
    return { files, newFiles: [] };
  }

  files.unshift({
    id: `${activeCase.id}_${fileTypes.alignmentAnalysis}_${planFile.name}`,
    name: planFile.name,
    type: fileTypes.alignmentAnalysis,
    date,
    userId,
  });

  return { files, newFiles: [planFile] };
};
